var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommonVariationView',{attrs:{"type":"amendment","reporter":"contractor","contract":_vm.contract,"items":_vm.items,"form-fields":_vm.formFields},on:{"FETCH_DATA":_vm.handleFetchData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }